import { Text, Accordion } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { IconBaseProps } from "react-icons";

export interface IAccordionDescriptionsItem {
  Icon?: React.ComponentType<IconBaseProps>;
  Panel: React.ReactNode;
  title: string;
  value: string;
}
export default function AccordionDescriptionsItem(
  props: IAccordionDescriptionsItem
) {
  const { Icon, Panel, title, value } = props;
  const { t } = useTranslation();

  return (
    <Accordion.Item value={value}>
      <Accordion.Control>
        {Icon && <Icon size="32px" color="#2F2F2F" />}
        <Text fz="24px" fw={700} lh="32px" color="basic.5">
          {t(title)}
        </Text>
      </Accordion.Control>
      <Accordion.Panel>{Panel}</Accordion.Panel>
    </Accordion.Item>
  );
}
